import React from "react";
import SEO from "@/components/SEO";

export default function RefundPage() {
  return (
    <>
      <SEO
        title="Refund & Cancellation Policy"
        description="Bill Forge Refund and Cancellation Policy. Learn about our refund policy, free trial terms, and cancellation process. Clear and transparent policies for our invoicing software."
        path="/refund"
      />
      <div className="bg-background">
      <section className="py-20 bg-gradient-to-b from-primary/5 to-background">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl sm:text-5xl font-bold font-manrope mb-6">
            Refund & Cancellation Policy
          </h1>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Last updated: {new Date().toLocaleDateString()}
          </p>
        </div>
      </section>

      <section className="py-20 bg-background">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-card border border-border rounded-2xl p-8 md:p-12">
            <div className="prose prose-slate max-w-none">
              <h2 className="text-2xl font-bold font-manrope mb-4">1. Subscription Refunds</h2>
              <p className="text-muted-foreground mb-6">
                All subscriptions are billed in advance on a recurring basis (monthly or annually).
                Due to the nature of digital services, we do not offer refunds for partial months
                or unused portions of your subscription.
              </p>

              <h2 className="text-2xl font-bold font-manrope mb-4">2. Free Trial</h2>
              <p className="text-muted-foreground mb-6">
                New users are eligible for a 14-day free trial. No payment is required during the
                trial period. If you do not cancel before the trial ends, your account will be
                automatically converted to a paid subscription.
              </p>

              <h2 className="text-2xl font-bold font-manrope mb-4">3. Cancellation Policy</h2>
              <p className="text-muted-foreground mb-6">
                You may cancel your subscription at any time through your account settings or by
                contacting our support team. Upon cancellation, you will retain access to your
                account until the end of your current billing period. No refunds will be issued
                for the remaining portion of your billing cycle.
              </p>

              <h2 className="text-2xl font-bold font-manrope mb-4">4. Refund Exceptions</h2>
              <p className="text-muted-foreground mb-6">
                In rare cases where service disruptions or technical issues prevent you from
                using the service as intended, we may consider refund requests on a case-by-case
                basis. Such requests must be made within 30 days of the issue and will be
                evaluated by our support team.
              </p>

              <h2 className="text-2xl font-bold font-manrope mb-4">5. Payment Method Issues</h2>
              <p className="text-muted-foreground mb-6">
                If you experience billing errors or unauthorized charges, please contact us
                immediately at info@codingwithdevam.cloud. We will investigate and resolve any
                legitimate billing discrepancies within 5-10 business days.
              </p>

              <h2 className="text-2xl font-bold font-manrope mb-4">6. Changes to This Policy</h2>
              <p className="text-muted-foreground mb-6">
                We reserve the right to modify this refund and cancellation policy at any time.
                Changes will be effective immediately upon posting to our website. Continued use of
                the service after policy changes constitutes acceptance of the new terms.
              </p>

              <h2 className="text-2xl font-bold font-manrope mb-4">7. Contact</h2>
              <p className="text-muted-foreground">
                For questions about refunds or cancellations, please contact us at
                info@codingwithdevam.cloud
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
    </>
  );
}
